import React from 'react';
import { Link } from 'react-router-dom';
import { FiBarChart2, FiActivity, FiBookOpen } from 'react-icons/fi';
import { MARKETS } from '../lib/config';

const HomePage: React.FC = () => {
  return (
    <>
      <section className="hero">
        <h1 className="hero-title">CCFOS</h1>
        <p className="hero-markets">{MARKETS.join(' · ')}</p>
        <p className="hero-sub">
          A charting &amp; indicator platform built by educators. We build the
          indicators and teach you how to read them — across every major market.
        </p>
        <div className="hero-cta">
          <Link to="/charts" className="btn btn-primary">Open charts</Link>
          <Link to="/learn" className="btn btn-ghost">Start learning</Link>
        </div>
      </section>

      <section className="cards">
        <FeatureCard
          icon={<FiBarChart2 />}
          title="Original indicators"
          body="Purpose-built technical indicators for trend, structure, and momentum — designed to teach, not to promise."
        />
        <FeatureCard
          icon={<FiActivity />}
          title="Illustrative ideas"
          body="See how a setup forms on live/delayed charts — as a worked teaching example, never as personalized advice."
        />
        <FeatureCard
          icon={<FiBookOpen />}
          title="Learn by doing"
          body="Walkthroughs that connect the indicator, the chart, and the reasoning so you can study markets for yourself."
        />
      </section>

      <section className="edu-callout">
        <h2>Education first — always</h2>
        <p>
          CCFOS exists to help you <em>understand</em> markets. Everything here is for
          educational purposes only. We are educators; we do not manage money, place
          trades, or tell anyone what to buy or sell. Any chart, indicator, or "idea"
          shown is a teaching illustration — your decisions are your own.
        </p>
      </section>
    </>
  );
};

const FeatureCard: React.FC<{ icon: React.ReactNode; title: string; body: string }> = ({
  icon,
  title,
  body,
}) => (
  <div className="card">
    <div className="card-icon">{icon}</div>
    <h3>{title}</h3>
    <p>{body}</p>
  </div>
);

export default HomePage;
